import { MCFormisForm, MCSectionSchema } from "@maslul/common-services";
import { FormlyFieldConfig } from "@ngx-formly/core";

export class FormisFormStoreData {
    formisForm: MCFormisForm | undefined;
    formisFormModel: any = {};
    formisFormFields: Array<FormlyFieldConfig> | undefined = [];
    schemas: Array<MCSectionSchema> | undefined;
}